import AdminCollapsible from '../components/AdminCollapsible';
import AdminSteps from '../components/AdminSteps';

const SOLUTION_KEYS = [
  { key: 'automation', label: 'Automation' },
  { key: 'chatbots', label: 'Chatbots' },
  { key: 'ml', label: 'Machine learning' },
  { key: 'strategy', label: 'Strategy' },
];

export default function MediaEditor({ content, onChange }) {
  const media = content.media;
  const solutionVideos = media.solutionVideos || {};

  const setMedia = (patch) => onChange({ ...content, media: { ...media, ...patch } });

  return (
    <div className="admin-panel">
      <div className="admin-panel__head">
        <div>
          <h2>Media URLs</h2>
          <p className="admin-panel__desc">Change video links used on the site (no code needed).</p>
        </div>
      </div>

      <AdminSteps />

      <AdminCollapsible title="Blog videos" hint="Usually edited in Blog tab too">
        <div className="admin-field">
          <label>Blog hero video</label>
          <input
            value={media.blogHeroVideo || ''}
            onChange={(e) => {
              const blogHeroVideo = e.target.value;
              setMedia({ blogHeroVideo });
              onChange({
                ...content,
                media: { ...content.media, blogHeroVideo },
                blogs: { ...content.blogs, heroVideo: blogHeroVideo },
              });
            }}
          />
        </div>
        <div className="admin-field">
          <label>Blog card videos (one per line)</label>
          <textarea
            rows={5}
            value={(media.blogVideoPool || []).join('\n')}
            onChange={(e) => {
              const blogVideoPool = e.target.value
                .split('\n')
                .map((s) => s.trim())
                .filter(Boolean);
              setMedia({ blogVideoPool });
              onChange({
                ...content,
                media: { ...content.media, blogVideoPool },
                blogs: { ...content.blogs, videoPool: blogVideoPool },
              });
            }}
          />
        </div>
      </AdminCollapsible>

      <AdminCollapsible title="Home page — solution section videos" hint="4 tabs on homepage">
        {SOLUTION_KEYS.map(({ key, label }) => (
          <div key={key} className="admin-field">
            <label>{label}</label>
            <input
              value={solutionVideos[key] || ''}
              onChange={(e) => {
                const next = { ...solutionVideos, [key]: e.target.value };
                setMedia({ solutionVideos: next });
              }}
            />
          </div>
        ))}
      </AdminCollapsible>
    </div>
  );
}
